/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDelegationRequestResponse } from '../../models/user-delegation-request-response';

export interface GetDelegationById$Params {

/**
 * delegation id
 */
  id: number;
}

export function getDelegationById(http: HttpClient, rootUrl: string, params: GetDelegationById$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDelegationRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, getDelegationById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDelegationRequestResponse>;
    })
  );
}

getDelegationById.PATH = '/api/administration/delegations/{id}';
